import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './Home.css';

export const Home: React.FC = () => {
  return (
    <div className="home-container">
      <Helmet>
        <title>Small Office Units for Rent in Bagshot | Bagshot Offices</title>
        <meta name="description" content="Explore small office units for rent in Bagshot. High-specification, well-insulated offices in the centre of Bagshot with parking, Wi-Fi, and premium amenities." />
        <link rel="canonical" href="https://www.bagshot-offices.co.uk/" />
      </Helmet>
      <div className="home-content">
        <h1 className="home-title">Small Office Units for Rent in Bagshot</h1>
        <div className="home-cta-container">
          <Link to="/gallery" className="cta-button">View Offices</Link>
        </div>
      </div>
    </div>
  );
};
